export default __webpack_public_path__ + "static/media/continue-session.da43c052.png";